import React from "react";
import CampaignDetails from "./info/CampaignDetails";
import SystemInfo from "./info/SystemInfo";
const CampaignInfo = (props) => {
  const { record } = props;
  return (
    <div className="component">
      <CampaignDetails record={record} />
      <SystemInfo record={record} />
    </div>
  );
};
export default CampaignInfo;
